// HomePage.js
import React, { useReducer } from "react";
import { Helmet } from "react-helmet";

// Local components
import Header from "./Header";
import LayoutHeader from "./LayoutHeader";
import SearchSideContent from "./SearchSideContent";
import SearchBodyHeader from "./SearchBodyHeader";
import SiteInfo from "./SiteInfo";
import Footer from "./Footer";
import SearchBodyContent from "./SearchBodyContent";
import ScrollToTopButton from "./ScrollToTopButton";

// Reducer objects
import reducer from "../reducers/siteInfoReducer"
import initialState from "../reducers/initialState"

// SearchUI components
import searchConfig from "../searchui/createSearchConfig";
import {
  ErrorBoundary,
  SearchProvider,
  Paging,
  WithSearch
} from "@elastic/react-search-ui";
import { Layout } from "@elastic/react-search-ui-views";
import "@elastic/react-search-ui-views/lib/styles/styles.css";

// HomePage componenet
export default function HomePage() {
  return (
    <SearchProvider config={searchConfig}>
      <WithSearch mapContextToProps={({
        wasSearched,
        results,
        totalResults,
        resultsPerPage,
        isLoading }) => ({
          wasSearched,
          results,
          totalResults,
          resultsPerPage,
          isLoading })}>
        {({
          wasSearched,
          results,
          totalResults,
          resultsPerPage,
          isLoading }) => {

          // Total pages to use in Paging component
          var totalPagesCap = (Math.ceil(totalResults / resultsPerPage) < 100) ? Math.ceil(totalResults / resultsPerPage) : 100;

          // Flag for loading and no prior search
          var initial_loader = (isLoading && !wasSearched) ? true : false;

          // Reducer for SiteInfo component
          const [stateSI, dispatchSI] = useReducer(reducer, initialState.siteInfo);

          return (
            <div className="App">
              <ErrorBoundary>
                <Header dispatchSI={ dispatchSI } disableSearch={ false }/>
                <Layout
                  header={
                      <LayoutHeader dispatchSI={ dispatchSI } pageName="Firearms Reference Table"/>
                  }
                  sideContent={
                    <SearchSideContent initial_loader={ initial_loader } wasSearched={ wasSearched }/>
                  }
                  bodyContent={
                    <SearchBodyContent initialLoader={ initial_loader } results={ results } />
                  }
                  bodyHeader={
                    <SearchBodyHeader initial_loader={ initial_loader } wasSearched={ wasSearched } />
                  }
                  bodyFooter={!initial_loader && (<Paging totalPages={totalPagesCap} />)}
                />
              </ErrorBoundary>
              <Footer dispatchSI={ dispatchSI } />
              <SiteInfo stateSI={ stateSI } dispatchSI={ dispatchSI } />
              { (!initial_loader && wasSearched) && <ScrollToTopButton /> }
              <Helmet>
                <title>Canadian Firearms Data & Analytics | Armalytics</title>
              </Helmet>
            </div>
          );
        }}
      </WithSearch>
    </SearchProvider>
  );
}
